
import cusDateTime from '@/components/cusDateTime';
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import BizBrowse from '@/components/biz-browse';
export default {
name: "dynamic-single-field",
components:{
cusDateTime,
XTextarea,
BizBrowse
},
props:['dynamicData','field','isEdit'],
methods:{
valueChange(field){
this.$emit('valueChange',field);
},
dictChange(e,field){
this.dynamicData[field.fieldName + '_show'] = e.value;
},
bizChange(e,field){
this.dynamicData[field.fieldName] = e.idValue;
this.$set(this.dynamicData,field.fieldName + '_show',e.showValue);
}
}
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/dynamic-single-field.vue